import { render, staticRenderFns } from "./ArpReview.vue?vue&type=template&id=3b728f24&scoped=true&"
import script from "./ArpReview.vue?vue&type=script&lang=js&"
export * from "./ArpReview.vue?vue&type=script&lang=js&"
import style0 from "./ArpReview.vue?vue&type=style&index=0&id=3b728f24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b728f24",
  null
  
)

export default component.exports